var store = require('store')

// 存数据
exports.store_set = (key, value) => {
    store.set(key, value)
}

// 取数据
exports.store_get = (key) => {
    return store.get(key) || "";
}

// 清空数据
exports.store_clear_all = () => {
    store.clearAll()
}